import { Component, Input, OnInit, EventEmitter, ChangeDetectorRef, Output } from '@angular/core';
import { VerificationDataRequirements, VDResults } from 'ng-voxloud';

import { environment } from 'src/environments/environment';

export interface VDFormValue extends VDResults {
  type: string
}

@Component({
  selector: 'gdp-verfication-data-form',
  templateUrl: './verfication-data-form.component.html',
  styleUrls: ['./verfication-data-form.component.scss']
})
export class VerficationDataFormComponent implements OnInit {
  @Input('language') language: string;
  @Input('loading') loading: boolean;
  @Input('country') country: string;
  @Input('requirements') requirements: VerificationDataRequirements;
  @Output() onValueChanged: EventEmitter<VDFormValue> = new EventEmitter();
  public selectedType: string = 'BUSINESS';
  public googlePlacesApiKey = environment.googlePlacesApiKey;

  constructor(
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

  }

  onValueEmitted(event: VDResults) {
    this.onValueChanged.emit({
      type: this.selectedType,
      isValid: event.isValid,
      value: event.value
    });
  }

  onRadioChange(type: string) {
    this.selectedType = type;
    this.cd.detectChanges();
  }
}
